export default function getRandomNumberInRange(min: any, max: any) {
  return Math.floor(Math.random() * (max - min + min));
}
